// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  height: 100%;
}

.logo {
  height: 25px;
  width: 117px;
}

.logo::before {
  background-repeat: no-repeat;
  background-size: contain;
  content: "";
  display: block;
  height: 30px;
  width: 117px;
}

mat-sidenav {
  border: unset;
  min-width: 250px;
}

/* stylelint-disable selector-class-pattern */
.sidenav__branding .sidenav__divider.no-branding {
  margin-bottom: 8px;
}

/* stylelint-enable selector-class-pattern */
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNpZGVuYXYuY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxhQUFBO0VBQ0EsWUFBQTtBQUNGOztBQUVBO0VBQ0UsWUFBQTtFQUNBLFlBQUE7QUFDRjs7QUFFQTtFQUNFLDRCQUFBO0VBQ0Esd0JBQUE7RUFDQSxXQUFBO0VBQ0EsY0FBQTtFQUNBLFlBQUE7RUFDQSxZQUFBO0FBQ0Y7O0FBRUE7RUFDRSxhQUFBO0VBQ0EsZ0JBQUE7QUFDRjs7QUFFQSw2Q0FBQTtBQUVFO0VBQ0Usa0JBQUE7QUFBSjs7QUFHQSw0Q0FBQSIsImZpbGUiOiJzaWRlbmF2LmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiOmhvc3Qge1xuICBkaXNwbGF5OiBmbGV4O1xuICBoZWlnaHQ6IDEwMCU7XG59XG5cbi5sb2dvIHtcbiAgaGVpZ2h0OiAyNXB4O1xuICB3aWR0aDogMTE3cHg7XG59XG5cbi5sb2dvOjpiZWZvcmUge1xuICBiYWNrZ3JvdW5kLXJlcGVhdDogbm8tcmVwZWF0O1xuICBiYWNrZ3JvdW5kLXNpemU6IGNvbnRhaW47XG4gIGNvbnRlbnQ6ICcnO1xuICBkaXNwbGF5OiBibG9jaztcbiAgaGVpZ2h0OiAzMHB4O1xuICB3aWR0aDogMTE3cHg7XG59XG5cbm1hdC1zaWRlbmF2IHtcbiAgYm9yZGVyOiB1bnNldDtcbiAgbWluLXdpZHRoOiAyNTBweDtcbn1cblxuLyogc3R5bGVsaW50LWRpc2FibGUgc2VsZWN0b3ItY2xhc3MtcGF0dGVybiAqL1xuLnNpZGVuYXZfX2JyYW5kaW5nIHtcbiAgLnNpZGVuYXZfX2RpdmlkZXIubm8tYnJhbmRpbmcge1xuICAgIG1hcmdpbi1ib3R0b206IDhweDtcbiAgfVxufVxuLyogc3R5bGVsaW50LWVuYWJsZSBzZWxlY3Rvci1jbGFzcy1wYXR0ZXJuICovXG4iXX0= */`, "",{"version":3,"sources":["webpack://./libs/shared/ng/base/src/lib/sidenav/components/sidenav/sidenav.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,YAAA;AACF;;AAEA;EACE,YAAA;EACA,YAAA;AACF;;AAEA;EACE,4BAAA;EACA,wBAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;AACF;;AAEA;EACE,aAAA;EACA,gBAAA;AACF;;AAEA,6CAAA;AAEE;EACE,kBAAA;AAAJ;;AAGA,4CAAA;AAAA,4oCAA4oC","sourcesContent":[":host {\n  display: flex;\n  height: 100%;\n}\n\n.logo {\n  height: 25px;\n  width: 117px;\n}\n\n.logo::before {\n  background-repeat: no-repeat;\n  background-size: contain;\n  content: '';\n  display: block;\n  height: 30px;\n  width: 117px;\n}\n\nmat-sidenav {\n  border: unset;\n  min-width: 250px;\n}\n\n/* stylelint-disable selector-class-pattern */\n.sidenav__branding {\n  .sidenav__divider.no-branding {\n    margin-bottom: 8px;\n  }\n}\n/* stylelint-enable selector-class-pattern */\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
